export const mapLayers = {
    'Fire Danger': [
        {   
            layerName: 'FDR_SFC',
            layerLabel: 'Fire Danger Rating',
            geoserverId: 'IDZ10134_AUS_AFDRS_fdr_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Hourly", // 'Daily', '3-Hourly', or 'Hourly'
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''
        },
        {
            layerName: 'FBI_SFC',
            layerLabel: 'Fire Behaviour Index',
            geoserverId: 'IDZ10135_AUS_AFDRS_fbi_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Hourly", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''
        },
        {
            layerName: 'MaxFDR_SFC',
            layerLabel: 'Max Fire Danger Rating',
            geoserverId: 'IDZ10136_AUS_AFDRS_max_fdr_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Daily", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''

        },
        {
            layerName: 'MaxFBI_SFC',
            layerLabel: 'Max Fire Behaviour Index',
            geoserverId: 'IDZ10137_AUS_AFDRS_max_fbi_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Daily", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''
        }
    ],
    'Fire Behaviour': [
        {
            layerName: 'ROS_SFC',
            layerLabel: 'Rate of Spread',
            geoserverId: 'IDZ10138_AUS_AFDRS_ros_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Hourly", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: 'm/h'
        },
        {
            layerName: 'FireIntensity_SFC',
            layerLabel: 'Fire Intensity',
            geoserverId: 'IDZ10139_AUS_AFDRS_intensity_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Hourly", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: 'KW/m'
        },
        {
            layerName: 'FH_SFC',
            layerLabel: 'Flame Height',
            geoserverId: 'IDZ10141_AUS_AFDRS_flame_height_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Hourly", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: 'm'

        },
        {
            layerName: 'SD_SFC',
            layerLabel: 'Spotting Distance',
            geoserverId: 'IDZ10142_AUS_AFDRS_spotting_distance_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Hourly", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: 'm'
        }
    ],
    'Fuel State': [
        {
            layerName: 'DF_SFC',
            layerLabel: 'Drought Factor',
            geoserverId: 'IDZ71127_AUS_DF_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Hourly", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''
        },
        {
            layerName: 'RFS_FuelAvailability_SFC',
            layerLabel: 'Fuel Availability',
            geoserverId: 'RFS_FuelAvailability_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Hourly", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''
        },
        {
            layerName: 'Curing_SFC',
            layerLabel: 'Grass Curing',
            geoserverId: 'IDZ10148_AUS_FSE_curing_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Daily", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: '%'
        },
        {
            layerName: 'GrassFuelLoad_SFC',
            layerLabel: 'Grass Fuel Load',
            geoserverId: 'IDZ10159_AUS_FSE_grass_fuel_load_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Daily", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: 't/ha'
        },
        {
            layerName: 'KBDI_SFC',
            layerLabel: 'KBDI',
            geoserverId: 'IDZ71147_AUS_KBDI_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Daily", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: 'mm'
        },
        {
            layerName: 'RFS_PBFT_SFC',
            layerLabel: 'Prescribed Burning',
            geoserverId: 'RFS_PBFT_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Hourly", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''
        },
        {
            layerName: 'SDI_SFC',
            layerLabel: 'SDI',
            geoserverId: 'IDZ71235_AUS_SDI_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Daily", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: 'mm'
        },
        {
            layerName: 'SMI_SFC',
            layerLabel: 'Soil Moisture Index',
            geoserverId: 'IDZ10145_AUS_AFDRS_awap_upper_soil_moisture_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "SingleStep", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''
        }
    ],
    'Continuous Haines': [
        {
            layerName: 'CHaines_SFC',
            layerLabel: 'Hourly',
            geoserverId: 'IDZ71115_AUS_CHaines_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Hourly", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''
        }
    ],
    'Lightning Activity Levels': [
        {
            layerName: 'LAL2_SFC',
            layerLabel: 'Activity Levels',
            geoserverId: 'IDZ71114_AUS_LAL2_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Hourly", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''
        }, {
            layerName: 'Lightning',
            layerLabel: 'Lightning Strikes (latest 24 hours)',
            layerWorkspace: null,
            legendFormat: 'image/png',
            serviceUrl: '{APP_BASE_URL}/bom/wms',
            geoserverId: 'Lightning',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''
        },
    ],
    'Cloud Cover': [
        {
            layerName: 'Sky_SFC',
            layerLabel: 'Cloud Cover',
            geoserverId: 'IDZ71017_AUS_Sky_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Hourly", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''
        }
    ],
    'Temperature': [
        {
            layerName: 'MaxT_SFC',
            layerLabel: 'Daily Maximum',
            geoserverId: 'IDZ71002_AUS_MaxT_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Daily", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: '<sup>o</sup>C'
        },
        {
            layerName: 'MinT_SFC',
            layerLabel: 'Daily Minimum',
            geoserverId: 'IDZ71003_AUS_MinT_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Daily", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: '<sup>o</sup>C'
        },
        {
            layerName: 'T_SFC',
            layerLabel: 'Hourly',
            geoserverId: 'IDZ71000_AUS_T_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Hourly", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: '<sup>o</sup>C'
        }
    ],
    'Humidity': [
        {
            layerName: 'RH_SFC',
            layerLabel: 'Relative Humidity',
            geoserverId: 'IDZ71018_AUS_RH_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Hourly", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: '%'
        },
        {
            layerName: 'Td_SFC',
            layerLabel: 'Dew Point Temperature',
            geoserverId: 'IDZ71001_AUS_Td_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Hourly", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: '<sup>o</sup>C'
        }
    ],
    'Wind': [
        {
            layerName: 'WindMagKmh_SFC',         
            layerLabel: '(Average) Wind Magnitude on Hour',
            geoserverId: 'IDZ71071_AUS_WindMagKmh_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeStepInterval: "Hourly",
            timeSteps: [],
            wmsVersion: '1.1.0',
            wmsFormat: 'png',
            legendUnits: 'km/h'
        },
        {
            layerName: 'WindMaxInHourMagKmh_SFC',
            layerLabel: '(Average) Wind Max In Hour',
            geoserverId: 'IDZ71073_AUS_WindMaxInHourMagKmh_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Hourly", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: 'km/h'
        },
        {
            layerName: 'WindMagKmh_1500mAMSL',
            layerLabel: '1500m Wind',
            geoserverId: 'IDZ71110_AUS_WindMagKmh_1500mAMSL',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeStepInterval: "Hourly",
            timeSteps: [],
            wmsVersion: '1.1.0',
            wmsFormat: 'png',
            legendUnits: 'km/h'
        },
        {
            layerName: 'MixHgt_SFC',
            layerLabel: 'Mixing Height',
            geoserverId: 'IDZ71109_AUS_MixHgt_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Hourly", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: 'm'
        }
    ],
    'Rainfall': [
        {
            layerName: 'DailyPrecip75Pct_SFC',
            layerLabel: 'Rainfall total 75% chance',
            geoserverId: 'IDZ71016_AUS_DailyPrecip75Pct_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Daily", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: 'mm'
        },
        {
            layerName: 'DailyPrecip50Pct_SFC',
            layerLabel: 'Rainfall total 50% chance',
            geoserverId: 'IDZ71015_AUS_DailyPrecip50Pct_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Daily", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: 'mm'

        },
        {
            layerName: 'DailyPrecip25Pct_SFC',
            layerLabel: 'Rainfall total 25% chance',
            geoserverId: 'IDZ71014_AUS_DailyPrecip25Pct_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Daily", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: 'mm'
        },
        {
            layerName: 'DailyPrecip10Pct_SFC',
            layerLabel: 'Rainfall total 10% chance',
            geoserverId: 'IDZ71030_AUS_DailyPrecip10Pct_SFC',
            layerType: 'Forecast_WMS',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "Daily", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: 'mm'
        }
    ],
    'Observations': [
        {
            layerName: 'WeatherStations',
            layerLabel: 'Weather Stations',
            geoserverId: 'weather_station',
            layerType: 'Observation',
            hasLegend: true,
            timeSteps: [],
            timeStepInterval: "", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''
        },
        {
            layerName: 'BOM_Radar',
            layerLabel: 'Weather Rain (Radar)',
            geoserverId: 'IDR00010',
            layerType: 'WMS',
            hasLegend: false,
            timeSteps: [],
            timeStepInterval: "", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''
        },
        {
            layerName: 'BOM_Wind',
            layerLabel: 'Weather Wind (Observation)',
            geoserverId: 'IDZ20010_wind',
            layerType: 'WMS',
            hasLegend: false,
            timeSteps: [],
            timeStepInterval: "", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''
        },
        {
            layerName: 'Himawari_TC',
            layerLabel: 'Himawari True Colour',
            geoserverId: 'IDE00435',
            layerType: 'WMS',
            hasLegend: false,
            timeSteps: [],
            timeStepInterval: "", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''
        },
        {
            layerName: 'Himawari_VG',
            layerLabel: 'Himawari Visible Greyscale',
            geoserverId: 'IDE00431',
            layerType: 'WMS',
            hasLegend: false,
            timeSteps: [],
            timeStepInterval: "", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''
        },
        {
            layerName: 'Himawari_ZFC',
            layerLabel: 'Himawari Zehr False Colour',
            geoserverId: 'IDE00433',
            layerType: 'WMS',
            hasLegend: false,
            timeSteps: [],
            timeStepInterval: "", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''

        }
    ],
    'Incident Weather Forecasts': [
        {
            layerName: 'IncidentForecast',
            layerLabel: 'Incident Weather Forecasts',
            geoserverId: 'incident_forecast',
            layerType: 'WMS',
            hasLegend: false,
            timeSteps: [],
            timeStepInterval: "", 
            wmsVersion: "1.1.0",
            wmsFormat: "png",
            legendUnits: ''
        }
    ]
}

export const extraMapLayers = {
    'Wind Direction': {
        geoserverId: 'IDZ71089_AUS_Wind_Dir_SFC',
        layerLabel: 'Wind Direction',
        layerType: 'WMS',
        hasLegend: true,
        timeSteps: [],
        timeStepInterval: "Hourly", 
        wmsVersion: "1.1.0",
        wmsFormat: "png",
        legendUnits: 'km/h'
    },
    '1500m Wind':{
        geoserverId: 'IDZ71111_AUS_Wind_Dir_1500mAMSL',
        layerLabel: '1500m Wind',
        layerType: 'WMS',
        hasLegend: true,
        timeSteps: [],
        timeStepInterval: "Hourly", 
        wmsVersion: "1.1.0",
        wmsFormat: "png",
        legendUnits: 'km/h'
    }
}